import {
  getSavedCameraFilter,
  toSnapFilterId,
} from "../camera/cameraFilterSettings";
import {
  getSnapFilterById,
  hasActiveSnapLens,
} from "../snap/config/snapFilters";

const SNAP_TOKEN_PLACEHOLDER = "PUT_STAGING_SNAP_API_TOKEN_HERE";

function isSnapCallFilterProbeEnabled() {
  const raw = String(process.env.REACT_APP_SNAP_CALL_FILTER_PROBE || "")
    .trim()
    .toLowerCase();
  return raw === "true";
}

function isProbeSnapTokenConfigured() {
  const token = String(process.env.REACT_APP_SNAP_API_TOKEN || "").trim();
  return Boolean(token && token !== SNAP_TOKEN_PLACEHOLDER);
}

function resolveProbeSelectedFilter() {
  const saved = getSavedCameraFilter();

  if (saved.provider !== "snap" || saved.id === "none") {
    return { selectedFilter: "none", wouldAttempt: false };
  }

  const snapId = toSnapFilterId(saved);
  const definition = getSnapFilterById(snapId);

  if (!definition || !hasActiveSnapLens(definition)) {
    return { selectedFilter: "none", wouldAttempt: false };
  }

  return {
    selectedFilter: saved.id,
    wouldAttempt: true,
  };
}

/**
 * Read-only Snap call filter probe — logs gate status only.
 * Never imports snapCallFilter.js, CameraKit, or Zego/media APIs.
 */
export function logSnapCallFilterProbe() {
  try {
    const enabled = isSnapCallFilterProbeEnabled();
    console.log(`[snapCallProbe] enabled=${enabled}`);

    if (!enabled) {
      return;
    }

    const tokenConfigured = isProbeSnapTokenConfigured();
    const { selectedFilter, wouldAttempt: filterReady } = resolveProbeSelectedFilter();
    const wouldAttempt = tokenConfigured && filterReady;

    console.log(`[snapCallProbe] tokenConfigured=${tokenConfigured}`);
    console.log(`[snapCallProbe] selectedFilter=${selectedFilter}`);
    console.log(`[snapCallProbe] wouldAttempt=${wouldAttempt}`);
    console.log("[snapCallProbe] applySkipped=probe_only");
  } catch {
    // Probe must never throw or block Web Zego startup.
  }
}
